import ApplicationController from '../application-controller';

export default class extends ApplicationController {
  static values = {
    cents: Number,
    saleCents: Number,
    format: String,
  };

  declare readonly hasCentsValue: boolean;
  declare readonly centsValue?: number;

  declare readonly hasSaleCentsValue: boolean;
  declare readonly saleCentsValue?: number;

  declare readonly hasFormatValue: boolean;
  declare readonly formatValue?: string;

  static targets = ['regularPrice', 'salePrice'];

  declare readonly hasRegularPriceTarget: boolean;
  declare readonly regularPriceTarget?: HTMLElement;
  declare readonly regularPriceTargets: HTMLElement[];

  declare readonly hasSalePriceTarget: boolean;
  declare readonly salePriceTarget?: HTMLElement;
  declare readonly salePriceTargets: HTMLElement[];

  getRegularCents(quantity: number) {
    if (this.hasCentsValue && this.centsValue) {
      return this.centsValue * quantity;
    }

    return 0;
  }

  getRegularIntegerPart(quantity: number) {
    const value = this.getRegularCents(quantity);

    return Math.floor(value / 100);
  }

  getRegularDecimalPart(quantity: number) {
    const value = this.getRegularCents(quantity);

    return value - this.getRegularIntegerPart(quantity) * 100;
  }

  formatRegularPrice(quantity: number = 1) {
    if (this.hasFormatValue && this.formatValue) {
      return this.formatValue
        .replace('11', this.getRegularIntegerPart(quantity).toString())
        .replace(
          '99',
          this.getRegularDecimalPart(quantity).toString().padStart(2, '0'),
        );
    }

    return '';
  }

  getSaleCents(quantity: number) {
    if (this.hasSaleCentsValue && this.saleCentsValue) {
      return this.saleCentsValue * quantity;
    }

    return 0;
  }

  getSaleIntegerPart(quantity: number) {
    const value = this.getSaleCents(quantity);

    return Math.floor(value / 100);
  }

  getSaleDecimalPart(quantity: number) {
    const value = this.getSaleCents(quantity);

    return value - this.getSaleIntegerPart(quantity) * 100;
  }

  formatSalePrice(quantity: number = 1) {
    if (this.hasFormatValue && this.formatValue) {
      return this.formatValue
        .replace('11', this.getSaleIntegerPart(quantity).toString())
        .replace(
          '99',
          this.getSaleDecimalPart(quantity).toString().padStart(2, '0'),
        );
    }

    return '';
  }

  recomputePrices(event: Event) {
    const quantity = Math.max(
      Number.parseInt((event.currentTarget as HTMLInputElement).value, 10),
      1,
    );

    this.regularPriceTargets.forEach((target) => {
      target.textContent = this.formatRegularPrice(quantity);
    });

    this.salePriceTargets.forEach((target) => {
      target.textContent = this.formatSalePrice(quantity);
    });
  }
}
